import { render, staticRenderFns } from "./TickettingList.vue?vue&type=template&id=9b274b48"
import script from "./TickettingList.vue?vue&type=script&lang=js"
export * from "./TickettingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports